import axios from 'axios';
import { format, parseISO } from 'date-fns';
import pt from 'date-fns/locale/pt-BR';
import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { MdWatchLater, MdShare, MdDirections } from 'react-icons/md';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

import notAvatar from '~/assets/avatar.png';
import battery from '~/assets/detailIcons/battery.svg';
import car from '~/assets/detailIcons/car.svg';
import directions from '~/assets/detailIcons/directions.svg';
import lock from '~/assets/detailIcons/lock.svg';
import odometer from '~/assets/detailIcons/odometer.svg';
import location from '~/assets/detailIcons/position.svg';
import unLock from '~/assets/detailIcons/unLock.svg';
import markerAlert from '~/assets/marker/markerAlert.svg';
import markerRun from '~/assets/marker/markerRun.svg';
import markerStop from '~/assets/marker/markerStop.svg';
import GoogleMap from '~/components/GoogleMap';
import { Marker } from '~/pages/Monitoring/styles';
import api from '~/services/api';
import { Creators as CommandActions } from '~/store/modules/command/duck';

import Modal from './Modal';
import ModalShare from './ModalShare';
import { Container, Content, Item, Action } from './styles';

import { useMonitoring } from '~/context/monitoring';

export default function DetailCar() {
  const { message, setMessage } = useMonitoring();

  const dispatch = useDispatch();
  const { id } = useParams();
  const trackers = useSelector((state) => state.buffer.trackers);
  const auth = useSelector((state) => state.auth);
  const [tracker, setTracker] = useState({});
  const [address, setAddress] = useState('clique para ver o endereço...');
  const [marker, setMarker] = useState(markerStop);
  const [alert, setAlert] = useState(null);
  const [angle, setAngle] = useState(0);
  const [isBlock, setIsBlock] = useState(false);
  const [dateFormated, setDateFormated] = useState('');
  const [mapConst, setMapConst] = useState(null);
  const [mapsConst, setMapsConst] = useState(null);
  const [hasCommand, setHasCommand] = useState(false);
  // const [address, setAddress] = useState('Carregando ...');
  const [routeInfo, setRouteInfo] = useState(null);

  function getDirections(angleTracker) {
    let nameAngle;
    if (angleTracker > 337.5 && angleTracker <= 22.5) nameAngle = 'Norte';
    if (angleTracker <= 22.5) nameAngle = 'Norte';
    if (angleTracker > 22.5 && angleTracker <= 67.5) nameAngle = 'Nordeste';
    if (angleTracker > 67.5 && angleTracker <= 112.5) nameAngle = 'Leste ';
    if (angleTracker > 112.5 && angleTracker <= 157.5) nameAngle = 'Sudeste';
    if (angleTracker > 157.5 && angleTracker <= 202.5) nameAngle = 'Sul';
    if (angleTracker > 202.5 && angleTracker <= 247.5) nameAngle = 'Sudoeste';
    if (angleTracker > 247.5 && angleTracker <= 292.5) nameAngle = 'Oeste';
    if (angleTracker > 292.5 && angleTracker <= 337.5) nameAngle = 'Noroeste';
    return setAngle(nameAngle);
  }

  async function getAddress(lat, lng) {
    if (lat && lng) {
      try {
        const { data } = await axios.get(
          `https://location.georastreamento.com.br/reverse.php?format=json&lat=${lat}&lon=${lng}&zoom=16`
        );
        const {
          road,
          city_district,
          town,
          city,
          state,
          village,
          suburb,
        } = data.address;
        setAddress(
          ` ${road || suburb || village || city_district}, ${
            city || town || city_district
          } - ${state}`
        );
      } catch (error) {
        setAddress('...');
      }
    }
  }

  useEffect(() => {
    if (trackers.length !== 0) {
      const data = trackers.find((t) => t.tracker_id == id);
      if (data) {
        getAddress(data.lat, data.lng);
        setTracker(data);
      }
    }
  }, [tracker, trackers, id]);

  useEffect(() => {
    setMessage('Verificando jornadas...');
    (async () => {
      try {
        const result = await api.get('/journeyroute', {
          validateStatus: false,
        });
        if (result.status === 200) {
          setRouteInfo(result.data);
        }
        if (result.status === 404) {
          toast.error('Não há jornadas iniciadas');
          setMessage('Não há jornadas iniciadas');
        }
      } catch (err) {
        setMessage('Não há jornadas iniciadas...');
        console.log('#119', err.message);
      }
    })();
  }, [id]);

  useEffect(() => {
    const data = trackers.find((t) => Number(t.tracker_id) === Number(id));
    if (data) {
      getAddress(data.lat, data.lng);
      setTracker(data);
    }
  }, [id]);

  useEffect(() => {
    async function getBlock() {
      try {
        const { data } = await api.get(
          `/hasCommand?tracker_id=${id}&type='BLOCK'`
        );
        setHasCommand(data.hascommand);
      } catch (error) {
        setHasCommand(false);
      }
    }
    getBlock();
  }, [id]);

  useEffect(() => {
    if (!_.isEmpty(tracker)) {
      dispatch(CommandActions.fetchCommandRequest(tracker.tracker_id));
      if (!_.isEmpty(mapConst)) {
        mapConst.setCenter(
          new window.google.maps.LatLng(tracker.lat, tracker.lng)
        );
        mapConst.setZoom(16);
      }
      const date = parseISO(tracker.date);
      const formated = format(date, 'dd/MM/yyyy HH:mm');
      setDateFormated(formated);
      if (tracker.status === 'DANGER') {
        setMarker(markerAlert);
      } else if (tracker.ignition) {
        setMarker(markerRun);
      } else {
        setMarker(markerStop);
      }

      if (tracker.status === 'DISCONNECTED') {
        setAlert('DISCONNECTED');
      } else if (tracker.alert_on) {
        setAlert('ALERT');
      } else {
        setAlert(null);
      }
      getDirections(tracker.angle);
      // getAddress(tracker.lat, tracker.lng);
      if (tracker.output1 || tracker.output2 || tracker.output3) {
        setIsBlock(true);
      } else {
        setIsBlock(false);
      }
    }
  }, [tracker]);

  function getMapBounds(map, maps, car) {
    if (car) {
      const bounds = new maps.LatLngBounds();

      bounds.extend(new maps.LatLng(car.lat, car.lng));
      return bounds;
    }
    return null;
  }

  function directionsRedirect(lat, lng) {
    window.open(
      `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`
    );
  }

  function mapLoad(map, maps) {
    // const bounds = getMapBounds(map, maps, tracker);
    map.setCenter(new window.google.maps.LatLng(tracker.lat, tracker.lng));
    map.setZoom(16);
    setMapConst(map);
    setMapsConst(maps);
  }

  function handleChangeBlock() {
    dispatch(CommandActions.setModal());
  }
  function handleShare() {
    dispatch(CommandActions.setModalShare());
  }

  return (
    <>
      <Container>
        <GoogleMap loadMap={(map, maps) => mapLoad(map, maps)}>
          {!_.isEmpty(tracker) && (
            <Marker
              key={tracker.tracker_id}
              alert={alert}
              rotate={tracker.angle}
              lat={tracker.lat}
              lng={tracker.lng}
            >
              <div>{tracker.label}</div>
              <img src={marker} alt="carros" />
            </Marker>
          )}
        </GoogleMap>
        <Content>
          <header>
            <img
              // src={
              //   tracker.driver_image
              //     ? `${process.env.REACT_APP_SERVER_FILE}/${tracker.driver_image}`
              //     : notAvatar
              // }
              src={notAvatar}
              alt="Motorista"
            />
            <div>
              <strong>
                {tracker.driver ? tracker.driver : 'Sem motorista vinculado'}
              </strong>
              <small>{tracker.label} </small>
            </div>
            <span>
              <strong>
                {tracker.rpm && tracker.rpm < 9999 ? (
                  <div>
                    <strong>{tracker.speed} Km/h</strong>
                    <small>{tracker.rpm} RPM</small>
                  </div>
                ) : (
                  tracker.speed || '-'
                )}
              </strong>
              <small>{!(tracker.rpm && tracker.rpm < 9999) && 'Km/h'}</small>
            </span>
          </header>
          <aside>
            <Item>
              {!auth.passenger && (
                <>
                  <div>
                    <img src={car} alt="Carro" />
                    <small>{`${tracker.brand} ${tracker.model}`}</small>
                  </div>
                  <div>
                    <img src={directions} alt="Velocidade" />
                    <small>{`${angle} - (${tracker.lat}, ${tracker.lng})`}</small>
                  </div>
                  <div>
                    <img src={battery} alt="Voltagem" />
                    <small>{`${tracker.power_voltage} V`}</small>
                  </div>
                  <div>
                    <img src={odometer} alt="Odometro" />
                    <small>
                      {tracker.hour_meter
                        ? `${(tracker.h_meter / 60).toFixed(0)} H`
                        : `${(tracker.odometer / 1000).toFixed(0)} Km`}
                    </small>
                  </div>
                  <div>
                    <MdWatchLater size={20} color="#777" />
                    <small>{dateFormated}</small>
                  </div>
                </>
              )}
              <div>
                <img src={location} alt="Logradrouro" />
                <small>{address}</small>
              </div>
              {auth.passenger && <>{message}</>}
            </Item>
            {!auth.passenger && (
              <Action>
                {hasCommand && (
                  <button type="button" onClick={() => handleChangeBlock()}>
                    <img
                      src={isBlock ? lock : unLock}
                      alt={isBlock ? 'Desbloquear' : 'Bloquear'}
                    />
                  </button>
                )}
                <button type="button" onClick={() => handleShare()}>
                  <MdShare size={30} color="#333" />
                </button>
                <button
                  type="button"
                  onClick={() => directionsRedirect(tracker.lat, tracker.lng)}
                >
                  <MdDirections size={30} color="#333" />
                </button>
              </Action>
            )}
          </aside>
        </Content>
      </Container>
      <Modal tracker={tracker} isBlock={isBlock} />
      <ModalShare tracker={tracker} />
    </>
  );
}
